import { useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const savePreferences = async (classmateEnrollmentIds) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.put('/current-enrollment/course-assignment/preferences', {
    classmateEnrollmentIds
  })
  return data
}

export const useSavePreferences = () => {
  const [t] = useTranslation('translation', { keyPrefix: 'pages.data.courseAssignmentPreferences' })
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: savePreferences,
    hookName: 'useSavePreferences',
    errorMessage: 'Error saving course assignment preferences',
    onSuccess: () => {
      message.success(t('saveSuccess'), [3])
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPreferences'] })
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPeriod'] })
    }
  })
}
